import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importPaychexOnboardingError = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "PaychexOnboardingError" */
                '@perpay-web/fintech/components/composite/PaychexError/PaychexOnboardingError'
            ),
    );
